// import { get } from "../../../lib/api";

const sizeChart = {
  namespaced: true,
  state: () => ({}),

  mutations: {
  },

  actions: {
    async fetch (_, { productId }) {

      const res = await window.axios.get(`/api/store/size-chart/products/${productId}/chart`);

      return res
    }
  }

}

export default sizeChart
